import { pdf } from "@react-pdf/renderer";
import moment from "moment";

import API from "../../services/rest/api";
import DietPlanReactPdfDocument from "./DietPlanPdfDocument";

const getDietPlanPdfFilename = (patientName?: string) =>
  `${patientName || "Patient"}-Smart-Health-Diet-${moment().format(
    "YYYYMMDD_HHmmss",
  )}.pdf`;

const resolvePatientDetails = async (
  dietData: any,
  userDetails?: any,
  initialPatientDetails?: any,
) => {
  if (initialPatientDetails) {
    return initialPatientDetails;
  }

  if (!dietData?.patient_id) {
    return null;
  }

  try {
    const payload = {
      patient_id: dietData.patient_id,
      health_coach_id:
        dietData?.health_coach_id ||
        userDetails?.health_coach_id ||
        localStorage.getItem("health_coach_id"),
    };
    const response = await API.GetPatientDetails(payload);
    return response?.data ?? null;
  } catch (error) {
    console.error("Failed to fetch patient details for diet plan PDF:", error);
    return null;
  }
};

export const generateDietPlanPdfFileFromData = async (
  dietData: any,
  userDetails?: any,
  initialPatientDetails?: any,
): Promise<File> => {
  const patientDetails = await resolvePatientDetails(
    dietData,
    userDetails,
    initialPatientDetails,
  );

  const blob = await pdf(
    <DietPlanReactPdfDocument
      dietData={dietData}
      patientDetails={patientDetails}
    />,
  ).toBlob();

  const filename = getDietPlanPdfFilename(patientDetails?.name);
  return new File([blob], filename, { type: "application/pdf" });
};
